import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import React from "react";
import { store, history } from "./store";

import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";

import App from "./components/App";
import LanguageProvider from "./i18n/LanguageProvider";

ReactDOM.render(
    <Provider store={store}>
        <LanguageProvider>
            <ConnectedRouter history={history}>
                <Switch>
                    <Route path="/" component={App} />
                </Switch>
            </ConnectedRouter>
        </LanguageProvider>
    </Provider>,

    document.getElementById("root")
);
